import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("spbu_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const outlet = localStorage.getItem("spbu_active_outlet");
  if (outlet) config.headers["X-Outlet-Id"] = outlet;
  return config;
});

export const formatDetail = (detail) => {
  if (detail == null) return "Terjadi kesalahan.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
};
